// aa 插件对应组件的名字
import test from './test.vue';
test.install = Vue => Vue.component(test.name, test);
export default test;



// WEBPACK FOOTER //
// ./src/components/test/test.js